import React from 'react';
import { createRoot } from 'react-dom/client';
import { rootNode } from '@entegral/helpers.react/settings/root-node';
import { componentData } from '@entegral/helpers.react/settings/component-data';
import { MapSearch } from './components/map-search/index';

createRoot(rootNode).render(<MapSearch config={componentData} />);
